module.exports = __webpack_public_path__ + "static/media/donacion.6e4451bb.jpg";